import React from "react";
import { CircularProgress } from '@mui/material'; 
import "./index.css";


const LoadingInner = ({  isLoadingInner, loadingName }) => {
  return (
      <div className="loadingInner" aria-label="loading">
        {isLoadingInner ? 
              (
                loadingName === "mastermind" ? (
                  <span>Searching Mastermind articles. Please wait... <CircularProgress aria-label="Loading data" style={{ color: 'silver', width: '30px', height: '30px', marginBottom: '-10px' }} /></span>
                ) : (
                  <span>Loading... <CircularProgress aria-label="Loading data" style={{ color: 'silver', width: '30px', height: '30px', marginBottom: '-10px' }}  /></span>
                )
              )
        :
              ('')
        }
      </div>
  );
}

export default LoadingInner;
